import { useSelector } from "react-redux";

export default function NoRoute() {
  const { loading } = useSelector((state) => state.genericReducer);
  const { isAuthenticated } = useSelector((state) => state.userReducer);

  if (!loading) {
    if (isAuthenticated) {
      if (window.location.pathname !== "/home") {
        window.location.href = "/home";
      }
    } else {
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
  }

  return <></>;
}
